import styled from "styled-components";

export const QueryTransactionPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
`;

export const QueryTransactionsFormDiv = styled.div`
  width: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    width: 90%;
  }
`;

export const QueryTransactionsTableDiv = styled.div`
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: 30%;
  
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    width: 95%;
    padding: 5px;
  }
`;